import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall } = breakpoints;
const S = {};
const buttonTypes = ({ type }) => {
  const types = {
    one: css`
      color: var(--colors-woodsmoke);
      background-color: var(--colors-orange-base);

      &:hover {
        background-color: var(--colors-orange-bright);
      }

      &:active {
        background-color: var(--colors-orange-dark);
      }
    `,
    disabled: css`
      box-shadow: inset 0 0 0 0.125rem var(--colors-silver);
      color: var(--colors-silver);
      cursor: not-allowed;
      pointer-events: none;
    `,
    oneWeak: css`
      --shadow-color: var(--colors-orange-base);
      --shadow-width: 0.125rem;
      box-shadow: inset 0 0 0 var(--shadow-width) var(--shadow-color);
      color: var(--colors-orange-base);

      &:hover {
        --shadow-color: var(--colors-orange-bright);
        color: var(--colors-orange-bright);
      }

      &:focus {
        --shadow-color: var(--colors-orange-base);
        --shadow-width: 0.25rem;
        color: var(--colors-orange-bright);
      }

      &:active {
        --shadow-color: var(--colors-orange-dark);
        --shadow-width: 0.125rem;
        color: var(--colors-orange-dark);
      }
    `,
    two: css`
      --shadow-color: var(--colors-silver);
      --shadow-width: 0.125rem;
      box-shadow: inset 0 0 0 var(--shadow-width) var(--shadow-color);
      color: var(--colors-silver);

      &:hover,
      &:active {
        --shadow-color: var(--colors-white);
        color: var(--colors-white);
      }

      &:focus {
        --shadow-color: var(--colors-white);
        --shadow-width: 0.25rem;
        color: var(--colors-white);
      }

      &:active {
        --shadow-width: 0.125rem;
      }
    `,
    three: css`
      color: var(--colors-orange-base);
      height: auto;

      &:hover {
        color: var(--colors-orange-bright);
      }

      &:active {
        color: var(--colors-orange-dark);
      }
    `,
    four: css`
      color: var(--colors-silver);
      height: auto;

      &:hover {
        color: var(--colors-white);
      }

      &:active {
        color: var(--colors-silver-chalice);
      }
    `,
    five: css`
      --shadow-color: var(--colors-silver);
      --shadow-width: 0.125rem;
      box-shadow: inset 0 0 0 var(--shadow-width) var(--shadow-color);
      color: var(--colors-silver);

      &:hover {
        --shadow-color: var(--colors-white);
        color: var(--colors-white);
      }

      &:focus {
        --shadow-color: var(--colors-white);
        --shadow-width: 0.25rem;
        color: var(--colors-white);
      }

      &:active {
        --shadow-color: var(--colors-silver-chalice);
        --shadow-width: 0.125rem;
        color: var(--colors-silver-chalice);
      }
    `,
    six: css`
      color: var(--colors-woodsmoke);
      background-color: var(--colors-honey-gold-base);

      &:hover {
        background-color: var(--colors-honey-gold-light);
      }

      &:focus {
        --shadow-width: 0.25rem;
        --shadow-color: var(--colors-white);
        box-shadow: inset 0 0 0 var(--shadow-width) var(--shadow-color);
        background-color: var(--colors-honey-gold-base);
      }

      &:active {
        background-color: var(--colors-honey-gold-dark);
      }
    `,
    sixWeak: css`
      --shadow-color: var(--colors-honey-gold-base);
      --shadow-width: 0.125rem;
      box-shadow: inset 0 0 0 var(--shadow-width) var(--shadow-color);
      color: var(--colors-woodsmoke);

      &:hover {
        --shadow-color: var(--colors-honey-gold-light);
        color: var(--colors-scarpa-flow);
      }

      &:focus {
        --shadow-color: var(--colors-honey-gold-dark);
        --shadow-width: 0.25rem;
      }

      &:active {
        --shadow-color: var(--colors-honey-gold-dark);
        --shadow-width: 0.125rem;
      }
    `,
  };

  return types[type];
};

S.Button = styled.div`
  label: StyledButton;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 7.5rem;
  height: 2.5rem;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  transition-property: color, background-color, box-shadow;
  user-select: none;
  padding: 0 1rem;

  ${({ isWide }) =>
    isWide &&
    css`
      width: 100%;
    `}

  ${({ isLoading }) =>
    isLoading &&
    css`
      pointer-events: none;

      ${S.Button.Title} {
        visibility: hidden;
      }
    `}

  ${({ isWideOnMobile }) =>
    isWideOnMobile &&
    css`
      width: 100%;

      @media (${widthSmall}) {
        width: auto;
      }
    `}

  ${buttonTypes};

  @media (${widthSmall}) {
    display: inline-flex;
  }
`;

S.Button.Title = styled.span`
  text-transform: uppercase;
`;

S.Button.Loader = styled.svg`
  animation: infinite spin 0.6s linear;
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  fill: currentColor;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`;

export default S;
